import _regeneratorRuntime from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { CALL_API } from "../api.middleware";
import { USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAILED, USER_LOGOUT, LOCAL_AUTHENTICATION_SUCCESS, SKIP_LOCAL_AUTHENTICATION_SUCCESS, LOCAL_AUTH_USERNAME_SUCCESS, LOCAL_AUTH_PASSWORD_SUCCESS, FIRST_TIME_INSTALLATION_SUCCESS, REMEMBER_ME, AUTO_SELECT, USER_PAN, USER_LOGIN_REFRESH, USER_LOGIN_REFRESH_SUCCESS, USER_LOGIN_REFRESH_FAILED, POSTER_OPEN } from "../types/auth";
import { sendNotification } from "../../components/utils"; // export const userLogin = (params) => async (dispatch) => {
//   try {
//     return await dispatch({
//       [CALL_API]: {
//         url: "/GetUserLoginnew_v17",
//         params,
//         method: "GET",
//         showLoader: true,
//         types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAILED],
//       },
//     });
//   } catch (error) {
//     return { error };
//   }
// };

export var PosterOpen = function PosterOpen(value) {
  return {
    type: POSTER_OPEN,
    body: value
  };
};
export var userLogin = function userLogin(body) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/login",
                  body: body,
                  method: "POST",
                  types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAILED],
                  isLogin: true
                }));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                alert("".concat(_context.t0));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
export var RefreshLogin = function RefreshLogin() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/refresh_token",
                  method: "GET",
                  types: [USER_LOGIN_REFRESH, USER_LOGIN_REFRESH_SUCCESS, USER_LOGIN_REFRESH_FAILED]
                }));

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                alert("".concat(_context2.t0));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
export var generateOtp = function generateOtp(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/DistributorSignup",
                  params: params,
                  method: "GET"
                }));

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {
                  error: _context3.t0
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};
export var generateLoginOtp = function generateLoginOtp(body) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GenerateOTP_JMF",
                  body: body,
                  method: "POST"
                }));

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {
                  error: _context4.t0
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 6]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};
export var validateLoginOtp = function validateLoginOtp(body) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/ValidateOTP_JMF",
                  body: body,
                  method: "POST"
                }));

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  error: _context5.t0
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 6]]);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};
export var registration = function registration(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/DistributorAddUser",
                  params: params,
                  method: "GET"
                }));

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", {
                  error: _context6.t0
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 6]]);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};
export var forgotUserId = function forgotUserId(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(dispatch) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetForgotUsername",
                  params: params,
                  method: "GET"
                }));

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", {
                  error: _context7.t0
                });

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 6]]);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};
export var forgotPassword = function forgotPassword(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(dispatch) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetForgotPassword",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", {
                  error: _context8.t0
                });

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 6]]);
      }));

      return function (_x8) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};
export var resetPassword = function resetPassword(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(dispatch) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/ResetPassword",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 6:
                _context9.prev = 6;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", {
                  error: _context9.t0
                });

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 6]]);
      }));

      return function (_x9) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
};
export var passwordPolicy_JMF = function passwordPolicy_JMF(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(dispatch) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/PasswordPolicy_JMF",
                  params: params,
                  method: "GET",
                  isPassword: true
                }));

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 6:
                _context10.prev = 6;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", {
                  error: _context10.t0
                });

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 6]]);
      }));

      return function (_x10) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
};
export var userLogout = function userLogout() {
  return {
    type: USER_LOGOUT
  };
};
export var saveLocalAutentication = function saveLocalAutentication(authID) {
  return {
    type: LOCAL_AUTHENTICATION_SUCCESS,
    authID: authID
  };
};
export var skipLocalAutentication = function skipLocalAutentication(skipAuth) {
  return {
    type: SKIP_LOCAL_AUTHENTICATION_SUCCESS,
    skipAuth: skipAuth
  };
};
export var saveLocalAuthUserName = function saveLocalAuthUserName(userName) {
  return {
    type: LOCAL_AUTH_USERNAME_SUCCESS,
    userName: userName
  };
};
export var saveLocalAuthPassword = function saveLocalAuthPassword(password) {
  return {
    type: LOCAL_AUTH_PASSWORD_SUCCESS,
    password: password
  };
};
export var remberME = function remberME(value) {
  return {
    type: REMEMBER_ME,
    value: value
  };
};
export var saveFirstTimeInstallationKey = function saveFirstTimeInstallationKey(installed) {
  return {
    type: FIRST_TIME_INSTALLATION_SUCCESS,
    installed: installed
  };
};
export var AutoSelectObject = function AutoSelectObject(body) {
  return {
    type: AUTO_SELECT,
    body: body
  };
};
export var userPan = function userPan(Pan) {
  return {
    type: USER_PAN,
    body: Pan
  };
};